<template>
  <div class="neu-card-professionals-ctn">
    <div class="neu-card-professionals btn-min-height mx-auto">
      <div>
        <img style="background-image: url('/static-appopensalud/img/bgs/opt/doctor-male.svg');background-size:cover" class="vertical icon-width-prof" :src="src"/>
      </div>
    <div class="subtitle-professional mx-auto">
      <p v-html="paddedTitle"></p>
      <star-rating style="justify-content: space-around;" :star-size="20" :read-only="true" :show-rating="false"></star-rating>
      <span v-html="paddedSubtitle">
      </span>
    </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import es from '@/lang/es/public/views/opensalud-pacientes.json'
import en from '@/lang/en/public/views/opensalud-pacientes.json'
export default {
  name: 'neu-card-professional',
  components: {
    StarRating
  },
  i18n: {
    reviews: {
      es: es,
      en: en,
      mx: es
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number,
    iconColor: {
      type: String,
      required: false
    }
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines)}` : this.title
    },
    paddedSubtitle () {
      return this.subtitleLines ? `${'<br>'.repeat(this.titleLines)}${this.subtitle}${'&ensp;'}${this.$t('rev')}` : `${this.subtitle}${this.$i18n.t('rev')}`
    }
  }
}
</script>

<style lang="scss" scoped>
.img-icon {
        margin: auto;
        float: left;
        &.vertical {
          height: 150px;
          @include mobile {
            height: 150px;
          }
        }
        &:not(.vertical) {
          width: 100px;
          @include mobile {
            width: 150px;
          }
        }

        object-fit: cover;
      }
.neu-card-professionals-ctn {
  // position: relative;
  // display: flex !important;
    transition-duration: 1s;
    @include mobile {
      padding-top: 3rem;
    }
   
  .neu-card-professionals {
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: center;
    // position: relative;
    transition-duration: 1s;
    
    .btn-min-height{
      @include desktop{
       min-height: 30rem !important;
      }
      @include desktop-sm{
       min-height: 30rem !important;
      }
    }
    //   .icon-width-prof{
    // @include mobile{
    // -webkit-margin-after: 11rem !important;

    // }
    // @media screen and (min-width: 1024px) and (max-width: 1440px) {
    //   margin-top: 3rem;

    // }
    // }
    // position: relative;
    // display: inline-flex !important;
    .div {
      padding: 0.5rem;
    }
    img{
      // position: absolute;
      width: 9rem;
      height: 9rem;
      border-radius: 50%;
      transition-property: none;

    }
    /* &:hover {
      @include desktop {
        padding: 4rem 6rem;
      }
      @include desktop-sm {
        padding: 0rem 4rem;
      }

      transition-duration: 1s;
    } */
      .subtitle-professional  {
      
    text-align: center;

    p {
        @include mobile {
      width: 15rem !important;
      // margin-top: 13rem !important;
      // margin-bottom: 4.5rem !important;
    }
        @include desktop {
      width: 13rem !important;
    }
      color: black;
      font-weight: bold;
      text-align: center;
      font-size: 1.1rem;
      white-space: normal;
      // padding-bottom: 3rem;
    }
  }
    box-shadow: $custom-shadow;
    border: $border;
    border-radius: $border-radius;

    // Neu Icon vertically centered
    // span {
    //   display: contents;

    //   @include mobile{
    //     display: block;

    //   }
    // }
  }


}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardProfessional.vue